import { computerSettlementWeight, computeSeaPreApntdState } from '@g/utils/orderUtils'
import calc from 'calculatorjs'
import dayjs from 'dayjs'
import { discountInfo } from '@g/utils/couponUtils'
import {
  isSupserLong,
  getParcelAmount,
} from '@g/utils/parcelUtils'

function formatOrderParcelList (parcels) {
  return parcels.map((item) => {
    let giftType = ''
    if (item.trackingNo.indexOf('GIFTKNIFE') > -1) {
      giftType = 'GIFTKNIFE'
      item.extraInfo.tpTaobaoTradeItems = item.extraInfo.giftknife

      item.carrierName = ''
      item.carrier = ''
      item.trackingNo = '巧巧郎學堂畢業禮'

      item.desc = '巧巧開箱刀'
      item.extraInfo.tpttName = '巧巧開箱刀'
      item.extraInfo.tpttPic = item.extraInfo.giftknife[0].itemPic
    }
    if (item.trackingNo.indexOf('GIFTMK') > -1) {
      giftType = 'GIFTMK'
      item.extraInfo.tpTaobaoTradeItems = item.extraInfo.giftitems

      item.carrierName = ''
      item.carrier = ''
      // item.trackingNo = ''

      // item.desc = '巧巧開箱刀,巧巧學堂貼紙,開箱文發佈開通碼'
      item.extraInfo.tpttName = '馬克杯'
      item.extraInfo.tpttPic = item.extraInfo.giftitems[0].itemPic
    }

    item.giftType = giftType
    item.isPTYTKITS = item.trackingNo.indexOf('PTYTKITS') > -1
    item.isStorage = item.jyStorageAt !== '0000-00-00 00:00:00'
    item.isSupserLong = isSupserLong(item)
    return item
  })
}

const state = {
  changeCneeAddrData: {
    oid: null,
    addrItem: null, // 地址
    csType: '0', // 宅配或店配
  },
  maxPack: 50, // 单订单最大包裹数量
  maxPackMore20Weigh: 100, // 20kg以上的包裹不能下单超过10个
  unShipmentList: [], // 未出货订单列表
  needList: [
    {
      needKey: 'needCcBill',
      needName: '訂購證明',
      needCtxKey: 'ccBills',
      needCfmKey: 'ccBillsCfm',
    },
    {
      needKey: 'needCcFreeInsp',
      needName: '免憑商檢放行切結書',
      needCtxKey: 'ccFreeInsps',
      needCfmKey: 'ccFreeInspsCfm',
    },
    {
      needKey: 'needCcNccSelf',
      needName: 'NCC自用切結書',
      needCtxKey: 'ccNccSelfs',
      needCfmKey: 'ccNccSelfsCfm',
    },
    {
      needKey: 'needCcPrtlRel',
      needName: '部分放行申請書',
      needCtxKey: 'ccPrtlRels',
      needCfmKey: 'ccPrtlRelsCfm',
    },
    {
      needKey: 'needCcWaiver',
      needName: '放棄書',
      needCtxKey: 'ccWaivers',
      needCfmKey: 'ccWaiversCfm',
    },
    {
      needKey: 'needCcBevRel',
      needName: '押款放行申請書2聯、承諾書',
      needCtxKey: 'ccBevRels',
      needCfmKey: 'ccBevRelsCfm',
    },
  ],
}

const getters = {
}

const mutations = {
  setChangeCneeAddrData (state, value) {
    state.changeCneeAddrData = value
  },
  setUnShipmentList (state, value) {
    state.unShipmentList = value
  }
}

const actions = {
  index ({ state, commit, dispatch, rootState }, params) {
    params = params.params ? params : { params }
    return rootState.axios.get('/jyo/v1frontend/jyorder/index', params).then(async (res) => {
      res.data.list = await dispatch('formatOrder', res.data.list)
      return res
    })
  },
  searchSplice ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/jyorder/search-splice', { params, noShowError: true })
  },
  refund ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/refund', params)
  },
  refundMessy ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/refund-messy', params)
  },
  updatePush ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/update-push', params)
  },
  updateReceived ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/update-received', params)
  },
  // 更新订单申报人
  updateTradevan ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/update-tradevan', params)
  },
  // 更新延遲出貨10分鐘（每更新一次累加10分鐘）
  updateDelaypicktime ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/update-delaypicktime', params)
  },
  sendEmail ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jye/v1frontend/jyorder/send-email', params)
  },
  updateDelay0 ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/update-delay0', params)
  },
  resendPreApntd ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/resend-preapntd', params)
  },
  updatePreApntdx ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/update-preapntdx', params)
  },
  updateSeaCarrierApptat ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/update-sea-carrier-apptat', params)
  },
  view ({ state, dispatch, rootState }, params) {
    // if (params.oid) {
    //   return Promise.all(
    //     params.oid.split(',').map(oid => {
    //       return rootState.axios.get('/jyo/v1frontend/jyorder/view', {params: {oid}})
    //     })
    //   ).then(async (resList) => {
    //     resList[0].data.model = (await dispatch('formatOrder', resList.map(res => res.data.model)))[0]
    //     return resList[0]
    //   })
    // } else {
    return rootState.axios.get('/jyo/v1frontend/jyorder/view', { params }).then(async (res) => {
      if (res.data.list && res.data.list.length) {
        res.data.model = (await dispatch('formatOrder', res.data.list))[0]
        return res
      }

      res.data.model = (await dispatch('formatOrder', [res.data.model]))[0]
      return res
    })
    // }
  },
  shippingTracking ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/jyorder/shipping-tracking', { params })
  },
  searchAostnotracks ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/jyorder/search-aostnotracks', { params })
  },
  shippingTrackingShareToken ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/shipping-tracking-share-token', params)
  },
  shippingTrackingShare ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jyo/v1frontend/jyorder/shipping-tracking-share', { params })
  },
  rewardScratchCoin ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/reward-scratch-coin', params)
  },
  rewardScratchCoinAmount ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/reward-scratch-coin-amount', params, {
      noShowError: true,
    })
  },
  checkPreApntd ({ state, commit, rootState }, params) {
    return rootState.axios.post('/jyo/v1frontend/jyorder/check-pre-apntd', params)
  },
  formatOrder (_, orders) {
    orders = (orders || []).map(order => {
      try {
        const volWeightStat = {
          count: 0,
          weight: 0,
          chgWeight: 0,
          jyChgWeight: 0,
        }
        if (order.subtnos && order.subtnos.length) {
          order.subtnos.forEach(subtno => {
            subtno.stTrackingNoRaw = subtno.stTrackingNo
            if (subtno.stCarrier === '711') {
              subtno.stTrackingNo = `861${subtno.stTrackingNo}`
            }
          })
        }
        if (order.transport === 'air' || order.jyoSrTransport === 'air') {
          order.parcels.forEach(item => {
            item.volWeight = Number(item.volWeight)
            item.weight = Number(item.weight)
            if (item.volWeight > item.weight) {
              volWeightStat.count += 1
              if (item.weight * 3 < item.volWeight) {
                volWeightStat.weight = calc(`${volWeightStat.weight}+${item.volWeight / 2}`)
              } else {
                volWeightStat.weight = calc(`${volWeightStat.weight}+${item.weight}`)
              }
              volWeightStat.jyChgWeight = calc(`${volWeightStat.jyChgWeight}+${item.weight}`)
            // volWeightStat.weight = calc(`${volWeightStat.weight}+${item.volWeight}`)
            // if (item.volWeight > item.weight * 3) {
            //   volWeightStat.chgWeight = calc(`${item.volWeight}/2-${item.weight}+${volWeightStat.chgWeight}`)
            // }
            }
          })
        }

        order.jyoWeightTotal = (order.jyoWeight - volWeightStat.jyChgWeight + volWeightStat.weight - order.jyoExtraInfo.parcelsInfo['50gWeights']) || 0

        const isSingleDiscounts = order.jyoOneExpress === '1' && order.jyoSrTransport === 'se' // 海快有优惠
        const settlementWeight = computerSettlementWeight(
          isSingleDiscounts ? order.jyoWeightTotal : order.jyoChgWeight,
          order.jyoShippingRate.minWeight,
          !isSingleDiscounts,
          order.jyoSrTransport,
        )
        const fwFeeDiscounts = isSingleDiscounts ? calc.mul(order.jyoShippingRate.fwFee, 0.95) : order.jyoShippingRate.fwFee
        let needCrrMask = false // 需要口罩輸入許可
        // 口罩 口罩配件
        if (order.jyoShpMethod === '91' && (!order.jyoExtraInfo || !order.jyoExtraInfo.snapshotsCrr)) {
        // const maskNames = ['口罩', '口罩配件']
          const totalCount = order.cargoes
            .filter(cargoe => cargoe.ccName && cargoe.ccName.indexOf('口罩') > -1)
            .reduce((prev, curr) => calc.add(prev, curr.count), 0)
          needCrrMask = totalCount > 250
        }

        let needCcWrs = false
        let needCcIdc = false
        if (order.jyoTradevanAddress) {
          const wrsUploaed = order.jyoTradevanAddress.wrsStatus === 'pd' || order.jyoTradevanAddress.wrsStatus === 'ok'
          const idcUploaed = order.jyoTradevanAddress.idcStatus === 'pd' || order.jyoTradevanAddress.idcStatus === 'ok'
          needCcWrs = order.jyoShpMethod === '91' && !wrsUploaed
          needCcIdc = order.jyoShpMethod === '91' && !idcUploaed
          const isCompany = /^(\d{8})$/.test(order.jyoTradevanAddress.idNum)
          order.subtnos.forEach(subtno => {
            const stStatus = subtno.stStatus.split(',')
            if (stStatus.indexOf('ccWrs') > -1) {
              needCcWrs = !wrsUploaed
            }
            if (stStatus.indexOf('ccIdc') > -1) {
              needCcIdc = !idcUploaed
            }
          })
          if (isCompany) {
            needCcIdc = false
          }
        }
        if (order.jyoStatus === '9') {
        // needCcWrs = false
        // needCcIdc = false
        }
        const fee = {
        }
        let addFee = 0
        if (order.jyoExtraInfo.srInclTax === '1') {
          addFee = order.jyoShippingRate.taxFee || 0
        } else if (order.jyoExtraInfo.srInclFreq === '1') {
          addFee = order.jyoShippingRate.frtFee || 0
        }
        const parcelsFeeFormulas = order.jyoShippingRate.parcelsFeeFormulas
        if (order.jyoShippingRate.parcelsFeeVersion === 'ShippingRateCalcSea') {
          fee.parcelFee = order.jyoShippingRate.parcelsFee
        } else if (order.jyoShippingRate.parcelsFeeVersion === 'ShippingRateCalcTaxSplitAddl') {
          fee.srChgWeight = parcelsFeeFormulas.srChgWeight

          fee.fw = {
            price: Number(order.jyoShippingRate.fwFee),
            weight: 1000,
            fee: Number(order.jyoShippingRate.fwFee),
          }
          fee.aw = {
            price: calc.add(Number(order.jyoShippingRate.awFee), addFee),
            weight: calc.sub(fee.srChgWeight, 1000),
          }
          fee.aw.fee = Math.floor(calc(`${fee.aw.price} * (${fee.srChgWeight || 0} - 1000) / 1000`))

          // fee.fw = {
          // // price: calc.add(Number(order.jyoShippingRate.fwFee), addFee),
          //   price: Number(parcelsFeeFormulas.srFees[2]),
          //   weight: fee.srChgWeight,
          //   fee: Math.floor(calc(`${order.jyoShippingRate.fwFee} * ${fee.srChgWeight || 0} / 1000`)),
          // }
          fee.fw.fee = Math.floor(calc(`${fee.fw.price} * (${fee.srChgWeight || 0}) / 1000`))
          fee.parcelFee = calc.add(parcelsFeeFormulas.opFwFeesNoTax[4], parcelsFeeFormulas.opAwFeesNoTax[4])
          fee.taxType = 'noTax' // 不包税
          if (order.jyoShpMethod === '1' && order.jyoExtraInfo.srInclTax === '1') {
            fee.taxType = 'tax' // 全包税
            fee.taxFee = {
              ...parcelsFeeFormulas.taxFees
            }
            fee.taxFee[0] = Number(fee.taxFee[0])
          } else if (order.jyoShpMethod === '1' && order.jyoExtraInfo.srInclFreq === '1') {
            fee.taxType = 'frt' // 包頻繁稅
            fee.taxFee = {
              ...parcelsFeeFormulas.frtFees
            }
            fee.taxFee[0] = Number(fee.taxFee[0])
          }
          if (order.jyoShippingRate.srLabel?.startsWith('BIZECO')) {
            fee.taxFee = []
          }
        } else if (order.jyoShippingRate.parcelsFeeVersion === 'ShippingRateCalcTaxSplit' ||
           (parcelsFeeFormulas && parcelsFeeFormulas.taxFees)) {
          fee.srChgWeight = parcelsFeeFormulas.srChgWeight
          fee.fw = {
          // price: calc.add(Number(order.jyoShippingRate.fwFee), addFee),
            price: Number(parcelsFeeFormulas.srFees[2]),
            weight: fee.srChgWeight,
            fee: Math.floor(calc(`${order.jyoShippingRate.fwFee} * ${fee.srChgWeight || 0} / 1000`)),
          }
          fee.fw.fee = Math.floor(calc(`${fee.fw.price} * (${fee.srChgWeight || 0}) / 1000`))
          fee.parcelFee = fee.fw.fee
          fee.taxType = 'noTax' // 不包税
          if (order.jyoShpMethod === '1' && order.jyoExtraInfo.srInclTax === '1') {
            fee.taxType = 'tax' // 全包税
            fee.taxFee = {
              ...parcelsFeeFormulas.taxFees
            }
            fee.taxFee[0] = Number(fee.taxFee[0])
          } else if (order.jyoShpMethod === '1' && order.jyoExtraInfo.srInclFreq === '1') {
            fee.taxType = 'frt' // 包頻繁稅
            fee.taxFee = {
              ...parcelsFeeFormulas.frtFees
            }
            fee.taxFee[0] = Number(fee.taxFee[0])
          }
          // 旧的计费方式，包税/包頻繁稅也单独显示
          if (order.jyoShippingRate.parcelsFeeVersion !== 'ShippingRateCalcTaxSplit' && fee.taxFee) {
            order.jyoShippingRate.oldParcelsFeeVersion = order.jyoShippingRate.parcelsFeeVersion
            order.jyoShippingRate.parcelsFeeVersion = 'ShippingRateCalcTaxSplit'
            fee.fw.price = fee.fw.price - fee.taxFee[2]
            fee.fw.fee = fee.fw.price * fee.fw.weight / 1000
            fee.parcelFee = fee.fw.fee
          }

          if (order.jyoShippingRate.srLabel?.startsWith('BIZECO')) {
            fee.taxFee = []
          }
        } else if (order.jyoShippingRate.parcelsFeeFormulas) {
          fee.srChgWeight = settlementWeight
          // if (order.jyoOneExpress === '1') {
          //   fee.srChgWeight = Number(order.jyoChgWeight)
          // }
          if (order.jyoShippingRate.addlWeight > 0) {
            fee.fw = {
              price: Number(order.jyoShippingRate.fwFee),
              weight: 1000,
              fee: Number(order.jyoShippingRate.fwFee),
            }
            fee.aw = {
              price: calc.add(Number(order.jyoShippingRate.awFee), addFee),
              weight: calc.sub(fee.srChgWeight, 1000),
            }
            fee.aw.fee = Math.floor(calc(`${fee.aw.price} * (${fee.srChgWeight || 0} - 1000) / 1000`))
          } else {
            fee.fw = {
            // price: calc.add(Number(order.jyoShippingRate.fwFee), addFee),
              price: Number(order.jyoShippingRate.parcelsFeeFormulas.srFees[2]),
              weight: fee.srChgWeight,
              fee: Math.floor(calc(`${order.jyoShippingRate.fwFee} * ${fee.srChgWeight || 0} / 1000`)),
            }
            fee.fw.fee = Math.floor(calc(`${fee.fw.price} * (${fee.srChgWeight || 0}) / 1000`))
          }
          // fee.parcelFee = calc.add(fee.fw.fee, fee.aw && fee.aw.fee > 0 ? fee.aw.fee : 0)
          fee.parcelFee = Number(order.jyoShippingRate.parcelsFeeFormulas.srFees[4])
        } else {
          fee.srChgWeight = settlementWeight
          if (order.jyoShippingRate.addlWeight > 0) {
            // 加重费由后续逻辑统一处理，这里保留空分支避免改动既有计费行为。
          } else {
            fee.fw = {
              price: calc.add(Number(order.jyoShippingRate.fwFee || 0), addFee),
              weight: fee.srChgWeight,
              fee: Math.floor(calc(`${order.jyoShippingRate.fwFee || 0} * ${fee.srChgWeight || 0} / 1000`)),
            }
            fee.fw.fee = Math.floor(calc(`${fee.fw.price} * (${fee.srChgWeight || 0}) / 1000`))
            fee.parcelFee = calc.add(fee.fw.fee, fee.aw && fee.aw.fee > 0 ? fee.aw.fee : 0)
          }
        }
        let taxImgs = []
        let hasDecl = false
        if (order.subtnos && order.subtnos.length) {
          order.subtnos.forEach(subtno => {
            if (subtno.stExtraInfo && typeof subtno.stExtraInfo === 'string') {
              subtno.stExtraInfo = JSON.parse(subtno.stExtraInfo)
            }
            if (subtno.duties && subtno.duties.length) {
              taxImgs = taxImgs.concat(subtno.duties.map(d => d.dutyFile).filter(dutyFile => !!dutyFile && dutyFile !== '410'))
            } else if (subtno.stExtraInfo && subtno.stExtraInfo.taxImgs) {
              taxImgs = taxImgs.concat(subtno.stExtraInfo.taxImgs)
            }
            if (subtno.stCarrier === '711' && /^944/.test(subtno.stTrackingNo)) {
            // subtno.stTrackingNo = `861${subtno.stTrackingNo}`
            }
          })
          taxImgs = Array.from(new Set(taxImgs))

          hasDecl = !!order.subtnos.find(subtno => (subtno.goodscc && subtno.goodscc.gccExtras && subtno.goodscc.gccExtras.declFile) || (subtno.stExtraInfo && subtno.stExtraInfo.declFile))
        }
        let waitTaxImg = false
        if (!taxImgs.length && order.jyoStatus === '5') {
          if (order.jyoShpMethod === '81') {
            waitTaxImg = true
          } else if (order.jyoShpMethod === '91') {
            waitTaxImg = Number(order.jyoTradevanAddress.isCompany) === 1
          }
        }

        if (order.jyoCoupon && order.jyoCoupon.crid && order.jyoShippingRate.parcelsFeeFormulas) {
          order.discountInfo = discountInfo(order.jyoCoupon, {
            shippingRate: order.jyoShippingRate,
            oid: order.oid,
          })
        }

        let hawbNo = ''
        if (order.subtnos && order.subtnos.length) {
          hawbNo = order.subtnos[0].hawb
        } else if (order.jyoExtraInfo?.preHawbs) {
          hawbNo = order.jyoExtraInfo.preHawbs.airhawb || order.jyoExtraInfo.preHawbs.sehawb
        }

        const premiumInfo = {
          parcelsFee: order.jyoShippingRate.parcelsFee || 0,
          freeGoodsVal: Math.round(calc.mul(order.parcels.reduce((prev, curr) => {
            return calc.add(prev, getParcelAmount(curr) || 0)
          }, 0), 4.5)), // 免费保价
          addGoodsVal: Number(order.jyoExtraInfo.lostInsAmt || 0), // 自定义保价
          goodsVal: 0,
          apologyGold: '', // 歉意金
          total: ''
        }
        if (order.jyoIslandFee > 0) {
          premiumInfo.parcelsFee = calc.add(premiumInfo.parcelsFee, order.jyoIslandFee)
        }
        if (order.jyoHctPalletFee > 0) {
          premiumInfo.parcelsFee = calc.add(premiumInfo.parcelsFee, order.jyoHctPalletFee)
        }
        if (order.jyoHctCaiFee > 0) {
          premiumInfo.parcelsFee = calc.add(premiumInfo.parcelsFee, order.jyoHctCaiFee)
        }
        if (order.jyoApartFee > 0) {
          premiumInfo.parcelsFee = calc.add(premiumInfo.parcelsFee, order.jyoApartFee)
        }
        if (order.jyoExtraFees && order.jyoExtraFees.hmdeFee > 0) {
          premiumInfo.parcelsFee = calc.add(premiumInfo.parcelsFee, order.jyoExtraFees.hmdeFee)
        }
        if (order.jyoExtraFees && order.jyoExtraFees.sedeFee > 0) {
          premiumInfo.parcelsFee = calc.add(premiumInfo.parcelsFee, order.jyoExtraFees.sedeFee)
        }
        if (order.jyoExtraFees && order.jyoExtraFees.vanFee > 0) {
          premiumInfo.parcelsFee = calc.add(premiumInfo.parcelsFee, order.jyoExtraFees.vanFee)
        }
        if (order.jyoExtraFees?.extJkpayFee > 0) {
          if (!order.jyoPayBrief.startsWith('JKPAY')) {
            // 选了街口支付后又换成了T币，实际付款方式要用 jyoPayBrief 判断下是否 JKPAY
            order.jyoExtraFees.extJkpayFee = 0
          } else {
            order.jyoAmount = calc.add(order.jyoAmount, order.jyoExtraFees.extJkpayFee)
          }
        }
        premiumInfo.goodsVal = premiumInfo.freeGoodsVal + premiumInfo.addGoodsVal
        premiumInfo.apologyGold = Math.round(calc.mul(premiumInfo.goodsVal, 0.1))
        premiumInfo.total = calc(`${premiumInfo.goodsVal} + ${premiumInfo.apologyGold} + ${premiumInfo.parcelsFee}`)

        // let needPtytKitsZyqjsImgs = order.cargoes.find(item => item.ccName === '新冠病毒檢驗試劑' || item.ccName === '新冠快篩') && !order.jyoExtraInfo.ptytKitsZyqjsImgs

        // order.jyoExtraInfo.needPtytKitsZyqjsImgs = needPtytKitsZyqjsImgs // 提交自用切結書
        order.jyoExtraInfo.needPtytKitsZyqjsImgs = false

        const waitUploadPapers = [] // 判斷清關資料是否齊全
        state.needList.forEach(need => {
          if (order.jyoExtraInfo[need.needKey] === '1') {
            if (!order.jyoExtraInfo[need.needCtxKey] || !order.jyoExtraInfo[need.needCtxKey].length) {
              waitUploadPapers.push({
                type: need.needKey,
              })
            } else if (order.jyoExtraInfo[need.needCfmKey] && order.jyoExtraInfo[need.needCfmKey].length && order.jyoExtraInfo[need.needCfmKey][0] !== 'ok') {
              waitUploadPapers.push({
                type: need.needKey,
                error: order.jyoExtraInfo[need.needCfmKey][0],
              })
            }
          }
        })
        // 'needCcPrtlRel': 0,
        // 'needCcWaiver': 0,
        // 'needCcBevRel': 0

        let shp91Step = 0
        if (order.jyoShpMethod === '91') {
          if (order.jyoPayStatus === '1') {
            shp91Step = 1
          } else if (order.jyoPayStatus === '9') {
            if (order.jyoStatus === '32') {
              shp91Step = 2
            }
            if (order.jyoStatus === '34' || order.jyoStatus === '5' || order.jyoStatus === '9') {
              shp91Step = 5
            }
            if (order.jyoExtraInfo.ccDeclFiles && !order.jyoExtraInfo.ccDeclFilesCfm) {
              shp91Step = 3
            } else if (order.jyoExtraInfo.ccDeclFilesCfm && order.jyoExtraInfo.ccDeclFilesCfm[0] === 'ok' && order.jyoStatus === '32' && order.jyoTradevanAddress.wrsStatus === 'ok') {
              shp91Step = 4
            }
          }
        }

        if (order.jyoType === '7' && !order.jyoShippingRate.srTwAddress) {
          order.jyoShippingRate.srTwAddress = {
            label: '新北新莊自取店'
          }
        }

        const hasCcGcoAt = order.subtnos[0] && order.subtnos[0].ccGcoAt && order.subtnos[0].ccGcoAt !== '0000-00-00 00:00:00'

        let canCancelTime = 0
        if (order.jyoPayStatus === '9') {
          canCancelTime = dayjs(order.jyoPaidAt).add(1, 'minute').valueOf()
        }

        const seaPreApntdState = computeSeaPreApntdState(order)

        return {
          ...order,
          parcels: formatOrderParcelList(order.parcels),
          isSingleDiscounts,
          settlementWeight,
          fwFeeDiscounts,
          needCrrMask,
          needCcWrs,
          needCcIdc,
          waitUploadPapers,
          fee,
          taxImgs,
          hasDecl,
          waitTaxImg,
          volWeightStat,
          hawbNo,
          premiumInfo, // 保价信息
          shp91Step,
          hasCcGcoAt,
          canCancelTime,
          ...seaPreApntdState,
        }
      } catch (e) {
        console.log(e, order)
        return order
      }
    })

    return orders
  },
  formatOrderParcelList (_, parcels) {
    return formatOrderParcelList(parcels)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
